import React from 'react';

function DeleteIcon() {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='16'
			height='16'
			fill='none'
			viewBox='0 0 16 16'
		>
			<path
				stroke='#141414'
				strokeLinecap='round'
				d='M13 3.667l-.413 6.683c-.106 1.708-.159 2.561-.586 3.175-.212.304-.484.56-.8.752-.64.39-1.495.39-3.206.39-1.713 0-2.57 0-3.209-.39a2.666 2.666 0 01-.8-.754c-.428-.615-.48-1.47-.583-3.18L3 3.667M14 3.667H2M6 7.823h4M10.705 3.667l-.455-.94c-.302-.623-.454-.935-.714-1.13a1.335 1.335 0 00-.183-.114c-.29-.15-.636-.15-1.329-.15-.71 0-1.066 0-1.359.156a1.334 1.334 0 00-.186.12c-.263.202-.41.525-.705 1.172l-.404.886M7 10.436h2'
			></path>
		</svg>
	);
}

export default DeleteIcon;
